// extracted by mini-css-extract-plugin
module.exports = {"header":"AttachemntsData_header__19bax","secondInPair":"AttachemntsData_secondInPair__fm1Ci","attachments":"AttachemntsData_attachments__vt-pG"};